<template>
  <v-dialog v-model="dialogComputed" max-width="1000px" persistent>
    <v-card-title class="primary white--text py-2">
      {{ $t('ELE0163') }}
      <v-spacer />
      <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
    </v-card-title>
    <v-container fluid class="px-2 py-2 white">
      <QrPartLotInformationForm
        v-if="dialogComputed"
        :qrInformation="qrInformation"
        :partsInformation="partsInformation"
        :lotInformation="lotInformation"
      />
    </v-container>
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import Btn from '@/components/atoms/base/button/Btn'
import QrInformationForm from '@/components/organisms/terminal/form/QrInformationForm.vue'
import PartsInspInformationForm from '@/components/organisms/terminal/form/PartsInspInformationForm.vue'
import LotInspInformationForm from '@/components/organisms/terminal/form/LotInspInformationForm.vue'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
// import { OqcIqcCd } from '@/enum'
import dayjs from 'dayjs'
import QrPartLotInformationForm from '@/components/organisms/terminal/form/QrPartLotInformationForm.vue'

export default {
  name: 'BoxInformationDialog',

  components: { Btn, QrInformationForm, PartsInspInformationForm, LotInspInformationForm, QrPartLotInformationForm },

  mixins: [APIUtils, Message],

  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: true,
    },
    refNo: {
      type: String,
      required: true,
      default: null,
    },
  },

  data() {
    return {
      panel: [0, 1, 2],
      qrInformation: {
        companyCd: '',
        partCd: '',
        lotNo: '',
        qty: '',
        remarks: '',
      },
      partsInformation: {
        inspFiltering: '',
        inspTimingCd: '',
        partInspTimingName: '',
        inspBasicQty: '',
        inspLevelAqlRate: '',
        xrfLastDatetime: '',
        isXrfExpired: false,
        measIns: '',
      },
      lotInformation: {
        inspStatus: '',
        inspQty: '',
        acceptanceQty: '',
        lotQty: '',
        sampleSize: '',
        acQty: '',
        reQty: '',
      },
    }
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    close() {
      this.dialogComputed = false
    },
  },
  async mounted() {
    try {
      // let inspTimingCd = OqcIqcCd.IQC
      // if (this.$store.getters.canOQCOnly) {
      //   inspTimingCd = OqcIqcCd.OQC
      // }
      const params = {
        refNo: this.refNo,
        userCompanyCd: this.$store.getters.companyCd,
        inspTimingCd: this.$store.getters.getIQCorOQC,
      }
      const data = await API.get('/box/getBoxInfo', params)
      if (data) {
        this.qrInformation = {
          refNo: data.refNo,
          companyCd: data.manufacturerCd,
          partCd: data.partCd,
          partName: data.partName,
          lotNo: data.lotNo,
          qty: data.qty,
          remarks: data.remarks,
        }
        this.partsInformation = {
          inspFiltering: data.inspFilteringName,
          inspTimingCd: data.inspTimingCd,
          partInspTimingName: data.partInspTimingName,
          inspBasicQty: data.inspBasicQty,
          inspLevelAqlRate: data.aqlRateName,
          xrfLastDatetime: data.xrfLastDatetime ? dayjs(data.xrfLastDatetime).format('YYYY-MM-DD') : '',
          isXrfExpired: data.isXrfExpired,
          measIns: data.measInstName,
        }
        this.lotInformation = {
          inspStatus: this.$t(`InspIndex.InspStatusCd.${data.inspStatusCd}`),
          inspQty: data.inspQty,
          acceptanceQty: data.qty,
          lotQty: data.lotQty,
          sampleSize: data.aqlSamplingSize,
          acQty: data.acQty,
          reQty: data.reQty,
        }
      }
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0163') })))
    }
  },
}
</script>

<style>
.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
  color: white !important;
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: auto !important;
}
</style>
